import tableHeight from "./tableHeight";
var install = function install(Vue) {
  Vue.directive('el-height-adaptive-table', tableHeight);
};
if (window.Vue) {
  window.tableHeight = tableHeight;
  Vue.use(tableHeight); // eslint-disable-line
}
tableHeight.install = install;
export default tableHeight;